const chapterModule = {
  id: "7c205826-8720-3b35-884d-b4aa2a32b7f9",
  config: {
    general: {
      template: {
        label: "Left",
        component: "ChapterLeft",
      },
      paddings: {
        top: true,
        bottom: true,
      },
      backgroundColor: {
        label: "Powder Blue",
        value: "#bee0e5",
      },
      media: {
        url: "https://tc-media.job-shop.com/content-modules/cover/header/cover-header.jpg",
        mediaType: "image",
      },
      showMedia: false,
      showCta: true,
      showHeader: true,
    },
    header: {
      text: "Be yourself & more.",
      isTextInCaps: false,
      textColor: {
        label: "Black",
        value: "#000000",
      },
    },
    text: {
      text: "We’re change agents and cyber gurus. Performance improvers and problem solvers. Data scientists and growth hackers. Bot programmers and software builders. Risk managers and confidence builders. We’re more than 365,000 global perspectives ready to welcome yours.",
      textColor: {
        label: "Black",
        value: "#000000",
      },
    },
    ctaButton: {
      text: "Learn more",
      fillStyle: {
        label: "Fill",
        value: "fill",
      },
      corners: {
        label: "Round",
        value: "round",
      },
      link: {
        type: {
          label: "External Link",
          value: "external",
        },
        url: "https://www.example.com",
        scrollTarget: {
          label: "FAQ",
          value: "7c205826-8720-3b35-884d-b4aa2a32b7f9",
        },
      },
      backgroundColor: {
        label: "Black",
        value: "#000",
      },
      textColor: {
        label: "Green",
        value: "#2bcd41",
      },
    },
    media: {
      media: {
        url: "https://tc-media.job-shop.com/content-modules/cards/card/image/card-image.jpg",
        mediaType: "image",
      },
      mediaAltText: "Awesome image",
      corners: {
        label: "Round",
        value: "round",
      },
    },
  },
};

export default chapterModule;
